/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type StorefrontFeaturedSection_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontHome_viewer$ref: FragmentReference;
export type StorefrontHome_viewer = {|
  +$fragmentRefs: StorefrontFeaturedSection_viewer$ref,
  +$refType: StorefrontHome_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "StorefrontHome_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "StorefrontFeaturedSection_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'e604d626df963f5912fa6bbad941e3b7';
module.exports = node;
